// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__wra13","FooterIcon":"Footer_FooterIcon__mRfg7"};